export const formatDateString = (
  dateString: Date | string,
  options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
) => new Date(dateString).toLocaleDateString(undefined, options);
